import styles from "@/styles/Form.module.scss";
import classnames from "classnames";
import { useCallback, useState } from "react";
import { useController } from "react-hook-form";
import ErrorMessage from "./ErrorMessage";

export default function MultiLevelMultipleCheckboxField({
  options,
  control,
  name,
  error,
  title,
  help,
  required,
  row,
  selectedQuestionValues = () => {},
  subTitle,
  defaultValue = [],
  visible,
}) {
  const { field } = useController({
    control,
    name,
    defaultValue,
  });
  const [value, setValue] = useState(defaultValue);

  const handleChange = useCallback(
    (e) => {
      const newValue = (() => {
        if (e.target.checked) {
          return [...value, e.target.value];
        } else {
          return value.filter((v) => v !== e.target.value);
        }
      })();

      field.onChange(newValue);
      setValue(newValue);
      if (typeof selectedQuestionValues === "function") {
        selectedQuestionValues(newValue);
      }
    },
    [value, field, selectedQuestionValues]
  );

  return (
    <fieldset
      className={styles.questionInputField}
      style={visible ? {} : { display: "none" }}
    >
      {title && (
        <legend
          className={classnames(styles.formTitle, {
            [styles.required]: required,
          })}
        >
          {subTitle}.{title}
        </legend>
      )}
      {help && <span className={`${styles.help} ${styles.small}`}>{help}</span>}
      <div
        className={classnames(styles.multipleCheckbox, {
          [styles.row]: row,
        })}
      >
        {options.map((option, index) => (
          <div
            className={classnames(styles.checkbox)}
            key={`checkbox-${name}-${index}`}
          >
            <input
              id={`checkbox-${name}-${index}`}
              type="checkbox"
              value={option.value}
              onChange={handleChange}
              onBlur={field.onBlur}
            />
            <label
              htmlFor={`checkbox-${name}-${index}`}
              className={`${styles.label} ${styles.small} `}
              tabIndex="0"
              onBlur={field.onBlur}
            >
              <span>{option.label}</span>
            </label>
          </div>
        ))}
      </div>
      {error && <ErrorMessage msg={error} />}
    </fieldset>
  );
}
